import { fileServiceApiRoot } from '@/constants/fileConstants';

export const PACKAGE_API_URL = `${fileServiceApiRoot}/package/python/pyodide`;

export const TEXTJAM_TEMPLATES_DICTIONARY = {
  py:  { projectType: "python", templateId: "python", templateType: "default" },
  web: { projectType: "web",    templateId: "web",    templateType: "default" },
  p5:  { projectType: "web",    templateId: "p5",     templateType: "p5"      },
};

export const TEXTJAM_TEMPLATES_DEFAULT_FILE = {
  python: "main.py",
  web: "index.html",
  p5: "script.js",
}

export const TIMEOUT_RESPONSE_ERROR_CODE = 'ECONNABORTED';